import { render, staticRenderFns } from "./mediaPage.vue?vue&type=template&id=546accd9&scoped=true"
import script from "./mediaPage.vue?vue&type=script&lang=js"
export * from "./mediaPage.vue?vue&type=script&lang=js"
import style0 from "./mediaPage.vue?vue&type=style&index=0&id=546accd9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546accd9",
  null
  
)

export default component.exports